
import { useForm } from "react-hook-form";
import OutlinedInput from "@mui/material/OutlinedInput";
import { FormControl, InputLabel, Select, MenuItem, Tooltip, ListItemText, Button, TextField } from '@mui/material'
import React, { useState, useEffect } from 'react'
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "../../../../utils/fvAxios";
import BaseURL from "../../../../utils/base-uri.json";
import { getGlobalClientId, getToken, getOrgType, getOrgId } from "../../../../utils/Token";
import useFetch from "../../../../utils/useFetch"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export default function ReportVistors({ close, name }) {
  const [client, setClient] = React.useState([]);
  const [error, setError] = useState(null);
  const [sitedata, setSiteData] = React.useState([]);
  const [location, setLocation] = React.useState([]);
  const [Emp, setEmp] = React.useState([]);

  const { register } = useForm();
  const [selectValue1, setSelectValue1] = useState("");
  const [fromDateValue, setFromDateValue] = useState(null);
  const [toDateValue, setToDateValue] = useState(null);
  const [token, setToken] = useState(getToken())
  const changeClients = (e) => {
    setSelectValue1(e);
  };

  const timeZoneOffset = new Date().getTimezoneOffset()
  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };

  const { data: resps } = useFetch(
    "Vendor/GetLocationsByClientId?clientId=" + getOrgId()
  );
  useEffect(() => {
    if (resps?.data) {
      setLocation(resps?.data);
    }
  }, [resps]);

  const handleFromDateChange = (event) => {
    setFromDateValue(event);
  };

  const handleToDateChange = (event) => {
    setToDateValue(event);
  };
  const [selectedsite, setSelectedsite] = useState([]);
  const [selectedlocation, setSelectedLocation] = useState([]);
  const [selectedEmp, setSelectedEmp] = useState([]);

  const handleDocTypeChange1 = (event) => {
    setSelectedsite(event.target.value);
  };

  const handleDocTypeChange2 = (event) => {
    setSelectedLocation(event.target.value);
  };
  const handleEmpChange = (event) => {
    setSelectedEmp(event.target.value);
  };
  const { data: resp } = useFetch(
    "Client/GetVisitorsByLocation?locationID=" + selectedlocation
  );
  useEffect(() => {
    if (resp?.data) {
      setSiteData(resp?.data);
    }
  }, [resp]);


  const handleDateKeyDown = (e) => {
    e.preventDefault();// Prevent manual date input
  };

  return (
    <>
      <DialogTitle id="alert-dialog-title">{name}</DialogTitle>
      <DialogContent>
        <form
          action={
            BaseURL?.baseReportUrl + "GetOnsiteOffsiteVisitorsReport.aspx"
          }
          method="post"
          target="_blank"
        >
          <div style={{ marginLeft: "25px" }}>
            <FormControl sx={{ m: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                {" "}
                From{" "}
              </span>
              {/* <TextField
                type="date"
                sx={{ width: "320px" }}
                name="OOVisitorfromdate"
                size="small"
                value={fromDateValue || ""}
                onChange={handleFromDateChange}
                onKeyDown={handleDateKeyDown}
              /> */}
               <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month", "day"]}
                  value={fromDateValue}
                  onChange={handleFromDateChange}
                  name="fromDate"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                      }}
                      size="small"
                      name="fromDate"
                      onKeyDown={handleDateKeyDown}
                    />
                  )}
                />
              </LocalizationProvider>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                To
              </span>
              {/* <TextField
                type="date"
                sx={{ width: "320px" }}
                name="OOVisitortodate"
                size="small"
                value={toDateValue || ""}
                onChange={handleToDateChange}
                onKeyDown={handleDateKeyDown}
              /> */}
 <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month", "day"]}
                  value={toDateValue}
                  name="toDate"
                  onChange={handleToDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                      }}
                      name="toDate"
                      size="small"
                      onKeyDown={handleDateKeyDown}
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>

            <FormControl sx={{ marginLeft: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: 4,
                  marginBottom: "5px",
                }}
              >
                Location
              </span>
              <Select
                labelId="docs-label"
                id="docs-select"
                size="small"
                sx={{ width: "320px", overflow: "hidden" }}
                name="OOVisitorlocation"
                value={selectedlocation}
                onChange={handleDocTypeChange2}
                MenuProps={MenuProps}
                inputProps={{ "aria-label": "Select Documents" }}
              >
                {location?.map((item, index) => (
                  <MenuItem key={item?.key} value={item?.key}>
                    {item.value}
                  </MenuItem>
                ))}
                {/* {location.map((doc) => (
                  <MenuItem key={doc.key} value={doc.key}>
                    <Checkbox checked={selectedlocation.indexOf(doc.key) > -1} />
                    <ListItemText primary={doc.value} />
                  </MenuItem>
                ))} */}
              </Select>
            </FormControl>
            <FormControl sx={{ marginLeft: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: 4,
                  marginBottom: "5px",
                }}
              >
                Visitor
              </span>
              <Select
                labelId="docs-label"
                id="docs-select"
                size="small"
                sx={{ width: "320px", overflow: "hidden" }}
                name="OOvisitor"
                value={selectedsite}
                onChange={handleDocTypeChange1}
                MenuProps={MenuProps}
                inputProps={{ "aria-label": "Select Documents" }}
              >
                {sitedata?.map((item, index) => (
                  <MenuItem key={item?.value} value={item?.value}>
                    {item.key}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <input type="text" name="clientId"  value={getOrgId()} hidden="true"/>
            <input type="text" name="timeZoneOffset" value={timeZoneOffset} hidden="true" />
          </div>
          <DialogActions>
            <div className="login-help__buttonContainer">
              <Button
                variant="contained"
                className="login-help-button-cancel"
                onClick={close}
              >
                {" "}
                Cancel
              </Button>

              {fromDateValue == "" ||
                toDateValue == "" || selectedsite == "" || selectedlocation == "" ? (
                <Tooltip title="All the fields are mandatory" followCursor>
                  <span>
                    <Button
                      variant="contained"
                      className="login-button-request"
                      onClick={close}
                      disabled={
                        fromDateValue == "" ||
                        toDateValue == "" || selectedsite == "" || selectedlocation == ""
                      }
                    >
                      Create Report
                    </Button>
                  </span>
                </Tooltip>
              ) : (
                <Button
                  variant="contained"
                  type="submit"
                  className="login-button-request"
                  onClick={close}
                >
                  Create Report
                </Button>
              )}
            </div>
          </DialogActions>
          <input type="hidden" name="token" value={token} />
        </form>

        <br />
      </DialogContent>

    </>
  )
}
